// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-table th.el-table__cell{background-color:#eae3e3}.el-table td.el-table__cell,.el-table th.el-table__cell{color:#555;text-align:center}.el-form .el-form-item__content .el-select{width:100%}.el-message{min-height:100px}.el-message .el-message__content{font-size:22px}.el-message .el-icon svg{transform:scale(1.7)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
